import { BasicInfoSection } from 'app/shared/info-section/basic';
import { DetailItem } from 'app/shared/info-section/item';
import { toReadableNumber } from 'app/shared/utils/number';
import React from 'react';
import { useSelector } from 'react-redux';

export const WalletDetails = () => {
  const { email, sms, push } = useSelector((state) => state.wallet);
  return (
    <div>
      <BasicInfoSection title="Credit Balances">
        <DetailItem title="Email Credits">{toReadableNumber(email?.balance) || 0}</DetailItem>
        <DetailItem title="SMS Credits">{toReadableNumber(sms?.balance) || 0}</DetailItem>
        <DetailItem title="Push Credits">{toReadableNumber(push?.balance) || 0}</DetailItem>
      </BasicInfoSection>
    </div>
  );
};
